import { IconFormNames } from 'shared/assets/icons';
import {
  CompletionTargetUnit,
  FrequencyUnit,
  RruleReferenceDate,
  ScheduleCompletionActions,
  ScheduleEntryState,
} from 'shared/types/habit-schedule';
import { CreateTask } from 'shared/types/task';
import { TaskPriorityOptions, TaskType } from 'shared/types/task-base';
import * as yup from 'yup';

const schema = yup.object<CreateTask>({
  name: yup.string().required(),
  description: yup.string().nullable().optional(),
  type: yup
    .mixed<TaskType>()
    .oneOf(Object.values(TaskType) as TaskType[])
    .required(),
  deadlineDeadline: yup.date().nullable().optional(),
  endStrategy: yup
    .object({
      deadline: yup.date().nullable().optional(),
      completionCount: yup.number().integer().min(0).nullable().optional(),
    })
    .nullable()
    .optional(),
  goalId: yup.string().nullable().defined(),
  sectionId: yup.string().nullable().defined(),
  lifeAreaId: yup.string().nullable().defined(),
  tagIds: yup.array().of(yup.string().required()).nullable().defined(),
  reminderTime: yup.number().nullable().defined(),
  parentIds: yup.array().of(yup.string().required()).nullable().defined(),
  priority: yup
    .string()
    .oneOf(Object.values(TaskPriorityOptions))
    .nullable()
    .defined(),
  schedules: yup
    .array()
    .of(
      yup
        .object({
          startDate: yup.date().required(),
          rrule: yup
            .object({
              format: yup.string().required(),
              referenceDate: yup
                .string<RruleReferenceDate>()
                .oneOf(Object.values(RruleReferenceDate))
                .required(),
            })
            .required(),
          frequency: yup
            .object({
              count: yup.number().moreThan(0).required(),
              unit: yup
                .string<FrequencyUnit>()
                .oneOf(Object.values(FrequencyUnit))
                .required(),
            })
            .nullable(),
          completionTarget: yup.object({
            count: yup.number().required(),
            unit: yup
              .string<CompletionTargetUnit>()
              .oneOf(Object.values(CompletionTargetUnit))
              .required(),
          }),
          action: yup
            .object({
              type: yup
                .string<ScheduleCompletionActions>()
                .oneOf(Object.values(ScheduleCompletionActions))
                .required(),
            })
            .nullable()
            .default(null),
          entries: yup
            .array()
            .of(
              yup
                .object({
                  id: yup.string().required(),
                  date: yup.date().required(),
                  state: yup
                    .string()
                    .oneOf(Object.values(ScheduleEntryState))
                    .required(),
                  value: yup.number().moreThan(0).nullable(),
                })
                .required(),
            )
            .required(),
          endDate: yup.date().nullable(),
        })
        .required(),
    )
    .nullable()
    .defined(),
  timeslot: yup
    .object({
      startTime: yup.number().nullable().optional(),
      duration: yup.number().nullable().optional(),
    })
    .nullable()
    .optional(),
  hideOnTodo: yup.boolean().nullable().optional(),
  iconName: yup
    .mixed<IconFormNames>()
    .oneOf(Object.values(IconFormNames) as IconFormNames[])
    .nullable()
    .optional(),
});

export const createTaskValidation = (task: CreateTask) =>
  schema.validateSync(task, { stripUnknown: true }) as CreateTask | undefined;
